
import toast from "react-hot-toast";
import { useContext } from "react";
import { ProductsContext } from "../../providers/products";
import { CartContext } from "../../providers/cart";

import Card from "../../components/Card";

export const Shop = () => {
  const { products} = useContext(ProductsContext);
  const {cart, cartAdd, cartIncrement} = useContext(CartContext)
  

  const addNewProduct = (product) => {
    cartAdd(product);
  };

  console.log(cart);

  const incrementQuantity = (product) => {
    cartIncrement(product);
  };

  const handleShop = (product) => {
    toast.success("Colocou no Cofre");
    if (cart.every((item) => item.id !== product.id)) {
      return addNewProduct({ ...product, quantity: 1 });
    }
    return incrementQuantity(product);
  };

  return (
    <div className="main_content">
      <Card handleShop={handleShop} products={products} />
    </div>
  );
};
